import { render, staticRenderFns } from "./GameDescription.vue?vue&type=template&id=611c3974&scoped=true&"
import script from "./GameDescription.vue?vue&type=script&lang=js&"
export * from "./GameDescription.vue?vue&type=script&lang=js&"
import style0 from "./GameDescription.vue?vue&type=style&index=0&id=611c3974&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611c3974",
  null
  
)

export default component.exports